import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import apiClient from '../../services/apiClient'; 
import { Title } from '../../components'; 
import Breadcrumb from '../../components/UI/Breadcrumb';


const postNewSubject = async (subjectData) => {

  const { data } = await apiClient.post('/study-material/subjects', subjectData);
  return data;
};

const AddSubject = () => {

  const [category, setCategory] = useState('Semester Exams');
  const [subjectName, setSubjectName] = useState('');
  const [department, setDepartment] = useState('CSE');


  const mutation = useMutation({
    mutationFn: postNewSubject,
    onSuccess: (data) => {
      toast.success(`Successfully added: ${data.data.subjectName}`);
      
      setSubjectName('');
      setCategory('Semester Exams');
      setDepartment('CSE');
    },
    onError: (error) => {
      // Handle specific errors, like "subject already exists" (409)
      if (error.response?.status === 409) {
        toast.error(error.response.data.message); 
      }
      // Other errors are handled by the apiClient interceptor
    },
  });

  // --- Form Submit Handler ---
  const handleSubmit = (e) => {
    e.preventDefault();

    let subjectData = { category, subjectName };

    if (category === 'Semester Exams') {
      subjectData.department = department;
    }

    mutation.mutate(subjectData);
  };

  return (
    <>
      <Breadcrumb pageName="Add New Subject" />
      <Title>Study Material</Title>

      {/* Using styles from your LoginForm / AlumniVerification */}
      <div className="rounded-sm border border-stroke bg-white p-8 shadow-default dark:border-strokedark dark:bg-boxdark">
        <h3 className="mb-6 text-center text-2xl font-bold text-black dark:text-white">
          Add New Subject
        </h3>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Category Select */}
          <div className="flex flex-col">
            <label className="mb-2 block text-sm font-medium text-black dark:text-white">
              Category
            </label>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="w-full rounded border border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
            >
              <option value="Semester Exams">Semester Exams</option>
              <option value="Placements/Internships">Placements/Internships</option>
            </select>
          </div>

          {/* Department Select (Conditional) */}
          {category === 'Semester Exams' && (
            <div className="flex flex-col">
              <label className="mb-2 block text-sm font-medium text-black dark:text-white">
                Department
              </label>
              <select
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
                className="w-full rounded border border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
              >
                <option value="CSE">CSE</option>
                <option value="AI">AI</option>
                <option value="Common">Common</option>
              </select>
            </div>
          )}

          {/* Subject Name Input */}
          <div className="flex flex-col">
            <label className="mb-2 block text-sm font-medium text-black dark:text-white">
              Subject Name <span className="text-meta-1">*</span>
            </label>
            <input
              type="text"
              value={subjectName}
              onChange={(e) => setSubjectName(e.target.value)}
              placeholder="e.g., Data Structures and Algorithms"
              required
              className="w-full rounded border border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={mutation.isPending} 
            className="flex w-full justify-center rounded bg-primary p-3 font-medium text-gray hover:bg-opacity-90 disabled:opacity-50"
          >
            {mutation.isPending ? 'Adding...' : 'Add Subject'}
          </button>
        </form>
      </div>
    </>
  );
};

export default AddSubject;